import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25a0d71a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "agents-nav-item actions flex gap-[12px] flex-nowrap"
}

import IncrediButton from '@/components/common/incrediButton.vue';
import AgentBulkActionMenu from '@/components/agents-table/AgentBulkActionMenu.vue';
import { useUserRolePermissions } from '@/services/UserRolePermissions/UserRolePermissions';
import { computed, inject, onMounted, ref } from 'vue';
import { useSelectedAgentsLazyQuery } from '@/graphql/codegen/generated/graphql';
import { IKCoordinatorsService } from '@/modules/CoordinatorsService/CoordinatorService.InjectionKeys';
import { NetworkStatus } from '@apollo/client/core';
import { useAgentsTableUtils } from '@/views/agents/components/agents-table/agent-table-list/OS/agents-table.utils';
import { IKAgentsSelected } from '../../agents-table.InjectionKeys';


export default /*#__PURE__*/_defineComponent({
  __name: 'nav-bar-multiple-actions-btn',
  setup(__props) {

const userRolePermissions = useUserRolePermissions();
const selectedAgentsList = useSelectedAgentsLazyQuery();
const selectedAgents = inject(IKAgentsSelected);
const coordinatorService = inject(IKCoordinatorsService);
const agentBulkMenuVisible = ref(false);
const agentsTableUtils = useAgentsTableUtils();

onMounted(() => {
  selectedAgentsList.onResult(agents => {
    if (agents.networkStatus === NetworkStatus.ready) {
      agentBulkMenuVisible.value = (agents.data?.agents?.agents?.length || 0) > 1;
      const currentSelected = new Set(selectedAgents?.selectedAgentIds.value);
      agents.data?.agents?.agents?.forEach(agent => {
        if (agent?.id && agentsTableUtils.isCloudAgentInStatusStoppedOrUpdating(agent)) {
          currentSelected.delete(agent?.id);
        }
      });
      if (currentSelected.size !== selectedAgents?.selectedAgentIds.value?.size) {
        selectedAgents?.selectByIds(currentSelected);
      }
    }
  });
});

const isMultipleSelection = computed(() => (selectedAgents?.selectedAgentIds.value?.size || 0) > 1);
const openAgentActionsMenu = () => {
  if (agentBulkMenuVisible.value) return;
  const payload = {
    filter: {
      coordinatorId: coordinatorService?.selectedCoordinator.value,
      agentsIdFilter: Array.from(selectedAgents?.selectedAgentIds.value || []),
    },
  };
  if (selectedAgentsList.networkStatus.value) selectedAgentsList.refetch(payload);
  else selectedAgentsList.load(undefined, payload, { fetchPolicy: 'no-cache' });
};

return (_ctx: any,_cache: any) => {
  const _component_q_separator = _resolveComponent("q-separator")!

  return (_openBlock(), _createBlock(_Transition, { name: "multiple-action-btn-fade" }, {
    default: _withCtx(() => [
      (_unref(isMultipleSelection))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(IncrediButton, {
              visibility: (_unref(userRolePermissions).authorize?.value?.agents.enabled.actions && _unref(isMultipleSelection)) || _unref(selectedAgents)?.loading.value,
              "icon-right": "icon-down-small",
              "debounce-visibility-loading-time": 700,
              loading: _unref(selectedAgents)?.loading.value || _unref(selectedAgentsList).loading.value,
              label: "Actions",
              "data-testid": "agens-bulk-actions-button",
              class: _normalizeClass(["table-upper-buttons actions-btn bulk-actions-btn ibf-button2", { 'menu-is-open': agentBulkMenuVisible.value }]),
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => openAgentActionsMenu(), ["prevent"]))
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(AgentBulkActionMenu, {
                  key: _unref(selectedAgents)?.selectedAgentIds.value.size || 1,
                  modelValue: agentBulkMenuVisible.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((agentBulkMenuVisible).value = $event)),
                  agents: _unref(selectedAgentsList).result.value?.agents?.agents as any || []
                }, null, 8, ["modelValue", "agents"]))
              ]),
              _: 1
            }, 8, ["visibility", "loading", "class"]),
            (_unref(isMultipleSelection))
              ? (_openBlock(), _createBlock(_component_q_separator, {
                  key: 0,
                  class: "separator self-center",
                  vertical: ""
                }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})